<template>
  <div>
    <v-tooltip v-if="title" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon large color="sleep" v-bind="attrs" v-on="on" slot="activator" class="mt-2">
          mdi-account-tie
        </v-icon>
      </template>
      <span> {{ title }} </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CorporateChallengeIcon",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
